import {
  FETCH_DESK_LABELS_FULFILLED,
  FETCH_DESK_LABELS_PENDING,
  FETCH_DESK_LABELS_REJECTED,
} from '../actions/desk-bookings';
import type { DeskLabelsState } from '../../types';

const initialState: DeskLabelsState = {
  byDate: {},
  requestKey: null,
};

export function deskLabelsReducer(state: DeskLabelsState = initialState, action: any): DeskLabelsState {
  switch (action.type) {
    case FETCH_DESK_LABELS_PENDING:
      return { byDate: action.meta.key === state.requestKey ? state.byDate : {}, requestKey: action.meta.key };
    case FETCH_DESK_LABELS_FULFILLED:
      return action.meta.key === state.requestKey ? { ...state, byDate: action.payload } : state;
    case FETCH_DESK_LABELS_REJECTED:
      return action.meta.key === state.requestKey ? { ...state, byDate: {} } : state;
    default:
      return state;
  }
}
